import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import images from '../../services/images';
import ContentHeader from '../parts/ContentHeader';
import Layout from '../parts/Layout';
import helpers from '../../services/helpers';
import { httpRequest, httpAuthHeaders } from '../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../parts/Loader';
import initTreeView from '../../services/initTreeView';
 
export default function StarterTemplate (){
    const [loading, setLoading] = useState(0);
    const navigate = useNavigate();
    const [errors, setErrors] = useState([]);
   
    useEffect(() => {
        initTreeView()
        //Mounted
        //fetchDataList()
    }, []);


    return (
        <>
        <Layout page_title="Starter Page" menu="home" breadcrumbs={true}>
            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                <h3>Starter Page Template</h3>
            </div>
        </Layout>
        </>
    )
}